module.exports = require("jquery-confirm");